import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SyncService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/sync';

  public syncTagsWithIndameta(): Observable<void> {
    return this.http.post<void>(this.baseUrl + '/indameta', null);
  }

  public checkUserSession(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/user-session');
  }
}
